import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Web3 from "web3";
import Web3Modal from "web3modal";
import BasePageRoutes from './BasePageRoutes';
import { getChainData, getErcContract } from '../utils'
import { updateAccountStatusAsync, resetAppAsync } from './modules/smartContract';
import { showSuccessSnackbar } from './modules/Snackbar/snackbar.action';

function initWeb3(provider) {
    const web3 = new Web3(provider);
    web3.eth.extend({
        methods: [
            {
                name: "chainId",
                call: "eth_chainId",
                outputFormatter: web3.utils.hexToNumber,
            },
        ],
    });
    return web3;
}

export default function BasePage() {

    const INITIAL_STATE = useSelector((state) => state.etherium);

    const dispatch = useDispatch();

    const getNetwork = () => getChainData(INITIAL_STATE.chainId).network;

    const getProviderOptions = () => {
        const providerOptions = {
            metamask: {
                // package: WalletConnectProvider,
                options: {
                    infuraId: "5918063957ef4e8bae0348d54fa14ebb",
                },
            },
        };
        return providerOptions;
        //return new Web3.providers.HttpProvider("https://rinkeby.etherscan.io/address/0xf28a42ffb0ad9e1c0726e62e196b1a7a933c1335");
    };

    const web3Modal = new Web3Modal({
        network: getNetwork(),
        cacheProvider: true,
        providerOptions: getProviderOptions(),
    });

    const subscribeProvider = async (provider) => {
        if (!provider.on) {
            return;
        }
        provider.on("close", () => {
            resetApp();
        });
        provider.on("accountsChanged", async (accounts) => {
            console.log(accounts)
            if (accounts.length === 0) {
                resetApp();
            }
            document.location.reload();
            // dispatch(accountChangedAsync({ address: accounts[0] }));
        });
        provider.on("chainChanged", async (chainId) => {
            document.location.reload();
            // const networkId = await INITIAL_STATE.web3.eth.net.getId();
            // dispatch(chainChangedAsync({ chainId, networkId }));
        });
        provider.on("networkChanged", async (networkId) => {
            const { web3 } = INITIAL_STATE;
            document.location.reload();
            // const chainId = await web3.eth.chainId();
            // dispatch(networkChangedAsync({ chainId, networkId }));
        });
        provider.on("disconnect", (error) => {
            console.log(error, "errorrrr");
            resetApp()
        });
    };

    const resetApp = async () => {
        const { web3 } = INITIAL_STATE;
        if (web3 && web3.currentProvider && web3.currentProvider.close) {
            await web3.currentProvider.close();
        }
        await web3Modal.clearCachedProvider();
        dispatch(resetAppAsync());
        // dispatch(resetStakingAppAsync());
    };

    const onConnect = async () => {
        const provider = await web3Modal.connect();

        await subscribeProvider(provider);

        const web3 = await initWeb3(provider);

        const accounts = await web3.eth.getAccounts();
        console.log('accounts', accounts)
        const chainId = await web3.eth.chainId();
        console.log('chainId', chainId)

        const address = accounts[0];


        const networkId = await web3.eth.net.getId();
        console.log('networkId', networkId)

        let connected = false;

        let myContract = getErcContract(chainId, web3);

        if (!myContract) {
            dispatch(showSuccessSnackbar('error', "Invalid network. Please connect with the correct network", 70000));
        } else {
            connected = true;
        }
        await dispatch(
            updateAccountStatusAsync({
                web3,
                provider,
                connected: connected,
                address,
                chainId,
                networkId,
                web3Modal,
            })
        );
    };

    // useEffect(() => {
    //     onConnect()
    // }, [])

    return (
        <BasePageRoutes />
    )
}
